import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToProduct = () => {
    const productSection = document.getElementById('producto');
    if (productSection) {
      productSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const benefits = ['Elimina la parálisis de "no sé qué hacer"', 'Crea un PDF que se vea profesional', 'Aprende a vender por WhatsApp + Instagram', 'Plan de 7 días en solo 1–2 hrs al día'];
  return <section className="bg-black pt-6 pb-8 px-5" data-id="element-103">
      <div className="max-w-md mx-auto text-center" data-id="element-104">
        {/* Top Tagline */}
        <p className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-5" data-id="element-105">
          Mujer Digital 3.0
        </p>

        {/* Main Image */}
        <div className="mb-5" data-id="element-106">
          <img src="https://cdn.magicpatterns.com/uploads/aLNTQ1XfZkbWgVZu4v5GXG/ChatGPT_Image_5_feb_2026,_16_35_10.png" alt="Guía Mujer Digital 3.0" className="mx-auto rounded-2xl shadow-2xl w-full max-w-[280px]" data-id="element-107" />
        </div>

        {/* Main Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-2xl md:text-3xl font-bold text-white leading-tight" data-id="element-108">
          Crea y vende tu primer PDF en 7 días
        </motion.h1>

        {/* Subheadline */}
        <p className="text-xl text-white mt-2" data-id="element-109">
          —{' '}
          <span className="text-[#FF4DA6] font-semibold" data-id="element-110">
            usando solo tu celular
          </span>
        </p>

        {/* Support Text */}
        <p className="text-sm text-white italic mt-2" data-id="element-111">
          (aunque hoy no tengas idea qué vender)
        </p>

        {/* Gray Paragraph */}
        <p className="text-sm text-gray-400 mt-3 leading-relaxed" data-id="element-112">
          Una guía paso a paso para mujeres que quieren generar ingresos desde
          casa, sin inventario, sin diseño y <em data-id="element-113">"sin ser expertas"</em>…
        </p>

        {/* Primary Button */}
        <button onClick={scrollToProduct} className="bg-[#4CAF50] hover:bg-[#45a049] active:scale-[0.98] text-white font-semibold py-4 px-6 w-full rounded-full mt-5 text-base shadow-lg transition-all" data-id="element-114">
          Quiero mi guía "Mujer Digital 3.0"
        </button>

        {/* Bullet Benefits */}
        <div className="mt-6 space-y-2 text-left max-w-sm mx-auto" data-id="element-115">
          {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-3" data-id="element-116">
              <span className="text-[#FF4DA6] flex-shrink-0 mt-0.5" data-id="element-117">✓</span>
              <span className="text-sm text-white" data-id="element-118">{benefit}</span>
            </div>)}
        </div>
      </div>
    </section>;
}